import React, { useState } from 'react';
import s from './Navbar.module.scss';

//assets
import whitelogo from './assets/logoFustec.png';

//Material UI
import {
	Grid,
    Link,
    Menu
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
// import AccountBoxIcon from '@mui/icons-material/AccountBox';
import PhonelinkRingIcon from '@mui/icons-material/PhonelinkRing';
import { Typography } from '@mui/material';
const options = [
    {name: 'Sobre nosotros', href: '#about'},
    {name: 'Productos destacados', href: '#ProductGrid'},
    {name: 'Nuestros clientes', href: '#CustomerCarousel'},
]

const Navbar = ({ setOpen }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeMenuItem, setActiveMenuItem] = useState(null);

    const handleOpenMenu = (event, index) => {
        setAnchorEl(event.currentTarget);
        setActiveMenuItem(index);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
        setActiveMenuItem(null);
    };

    const handleMenuContainerMouseLeave = () => {
        if (Boolean(anchorEl)) {
        setAnchorEl(null);
        setActiveMenuItem(null);
        }
    };

    const defaultMessage = "Hola, necesito contactar un técnico!";
    const encodedMessage = encodeURIComponent(defaultMessage);
    const phoneNumber = "+5492235119636";
    const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

	return(
        <Grid container item xs={12} className={s.container}>
            <Grid container item xs={12} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Grid item xs={2} className={s.burger} sx={{mt: 1}}>
                    <MenuIcon sx={{fontSize: '3rem', color: '#EEEEEE'}} onClick={() => setOpen(true)}/>
                </Grid>
                
                <Grid item xs={10} sm={10} md={3} lg={3} className={s.logo}>
                    <Link href='#/about' sx={{textDecoration: 'none'}}>
                        <img 
                            src={whitelogo} 
                            alt="logo"   
                        />
                    </Link>
                </Grid>

                <Grid container item xs={7} sm={2} md={6} lg={6} className={s.items}>
                {options.map((item, i) => (
                    item.selector ? 
                        <Grid 
                            item 
                            xs={4} sx={{display: 'flex', alingItems: 'center', justifyContent: 'center'}}
                            key={i} 
                            onMouseEnter={(e) => handleOpenMenu(e, i)}
                            onMouseLeave={handleMenuContainerMouseLeave}
                        >   
                            <Link className={s.link} >
                                {item.name}
                            </Link>
                        
                        {activeMenuItem === i && (
                        <Menu sx={{
                            "& .MuiMenu-paper": { 
                            backgroundColor: '#22222299', 
                            // marginTop: '38px', 
                            zIndex: 999 }
                        }}
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleCloseMenu}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                            getContentAnchorEl={null}
                        >
                        </Menu>
                        )}
                    </Grid>
                    : 
                    <Grid 
                        item xs={4} 
                        sx={{display: 'flex', alingItems: 'center', justifyContent: 'center'}}
                        key={i} 
                    >
                        <Link href={item.href} className={s.link}>
                        {item.name}
                        </Link>
                    </Grid>
                    
                ))}
                </Grid>

                <Grid item xs={1} sm={2} md={3} lg={3} sx={{display: 'flex', alingItems: 'center', justifyContent: 'center', mt: 0.3}}>
                    <Grid xs={3}>
                        <Link href={whatsappLink} className={s.linkContact} sx={{ textDecoration: 'none' }}>         
                            <Typography sx={{fontSize: '1.1rem', fontFamily:'Product sans, sans-serif' , fontWeight:'500', color: '#EEEEEE', justifyContent: 'center', mr: 1, mt: 1}}>Servicio Técnico</Typography>
                            <PhonelinkRingIcon sx={{fontSize: '3rem', color: '#df0e3d', justifyContent: 'center', marginTop: 1.3}}/>
                        </Link>
                    </Grid>
                    
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Navbar;